import { render } from "./Pedidos.vue?vue&type=template&id=8ef9dc38&scoped=true"
import script from "./Pedidos.vue?vue&type=script&lang=js"
export * from "./Pedidos.vue?vue&type=script&lang=js"

import "./Pedidos.vue?vue&type=style&index=0&id=8ef9dc38&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ef9dc38"]])

export default __exports__